<div class="super-block">
  <div #overviewContainer></div>
  <div class="middle-bar flex justify-between">
    <div *ngIf="cursor$ | async as cursor">
      {{ cursor[0] }}<span class="mls">.{{ cursor[1] }}</span>
    </div>
    <div *ngIf="duration$ | async as duration">
      {{ duration[0] }}<span class="mls">.{{ duration[1] }}</span>
    </div>
  </div>
  <div #zoomedContainer></div>
  <div class="flex justify-end">
    <div [class.hidden]="!canZoom && zoom <= 1">
      <rk-icon-button
        [style]="{ backgroundColor: 'rgba(255, 127, 80, 0.1)', border: 'none' }"
        [disabled]="zoom === 1"
        [size]="25"
        [bordered]="true"
        color="brand"
        (click)="zoomOut()"
        faIcon="fa-minus"
      ></rk-icon-button>
      <span class="mr-2 ml-2">{{ 100 * zoom }} %</span>
      <rk-icon-button
        [style]="{ backgroundColor: 'rgba(255, 127, 80, 0.1)', border: 'none' }"
        [disabled]="!canZoom"
        [size]="25"
        [bordered]="true"
        color="brand"
        (click)="zoomIn()"
        faIcon="fa-plus"
      ></rk-icon-button>
    </div>
  </div>
  <div class="loader" *ngIf="isLoading">
    <rk-loader [isLoading]="true" [size]="35"></rk-loader>
  </div>
</div>
